import { sanitizeAeroPressGrind } from "@client-shared/utilities/productSyncUtilities";
import type { LocalisedProductConfig, ProductConfig } from "@shared/types";
import { setAvailableLocalisedTermOptions } from "./set-available-localised-term-options";

export const filterLocalisedProductConfigGrinds = (
  cfg: LocalisedProductConfig | undefined,
  productConfig: ProductConfig | undefined
): LocalisedProductConfig | undefined => {
  const productGrind = productConfig?.grind;
  if (!cfg || !productGrind?.length) {
    return cfg;
  }
  return {
    ...cfg,
    grind: setAvailableLocalisedTermOptions(cfg.grind, productGrind.map(sanitizeAeroPressGrind)),
  };
};
